export enum TabsFilterValue {
  ONGOING = 'ONGOING',
  STEPS = 'STEPS',
  NEWS = 'NEWS',
}
